<div class="flex-column gap">
    <app-table
        translatePrefix="ePrescriptions.medicationEntries."
        [columns]="columns"
        [items]="items()"
        selectionMode="single"
        (selectionChanged)="selection($event)"
        [showSearchBar]="false"
    >
    </app-table>
</div>

<div #dialogFooter class="p-dialog-footer">
    <app-action-buttons primaryButtonLabel="ePrescriptions.buttons.prescribeMedicationAgain"
        [primaryButtonDisability]="!canPrescribe()" (primaryClickEvent)="prescribe()"
        (secondaryClickEvent)="dialogRef.close()">
<!--        TODO -->
<!--        <app-button icon="pi-search" label="ePrescriptions.buttons.searchNewMedication" severity="secondary"-->
<!--            (clickEvent)="search()"></app-button>-->
    </app-action-buttons>
</div>
